import { useSelector } from "react-redux";
import Countdown from "react-countdown-now";
import { Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";

import Box from "components/Box";
import Col from "components/Col";
import Row from "components/Row";
import SubmitExam from "./SubmitExam";
import Question from "./Question";
import { firestoreRef } from "api";
import Page from "components/Page";
import HeaderBanner from "components/headerBanner/HeaderBanner";
import { getExamAction } from "../actions";
import QuestionPicker from "./QuestionPicker";
import { useActions } from "helpers/useActions";
import ChevronLeft from "mdi-react/ChevronLeftIcon";
import ChevronRight from "mdi-react/ChevronRightIcon";
import { startExamAction, submitExamAction } from "./actions";
import { PrimaryButton } from "components/Buttons/PrimaryButton";
import FullScreenLoader from "components/Loaders/FullScreenLoader";
import {
  getAppTime,
  getPaper,
  getQuestionsForPaper,
  getGroupsForPaper
} from "./firebase";
import NContainer from "components/NContainer";
import useLocalStorage from "helpers/useLocalStorage";
import useMedia from "helpers/useMedia";
import NumbersIcon from "mdi-react/NumericIcon";
import Modal, { useModal } from "components/Modal";
import Fade from "@material-ui/core/Fade";

export default function ExamQuizPage({ history, match }) {
  const examId = match.params.id;

  const [localLoading, setLocalLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [remainingTime, setRemainingTime] = useState();
  const [currentQuestionKey, setCurrentQuestionKey] = useState();
  const [playedQuestions, setPlayed] = useLocalStorage("playedQUestions", []);
  const [examTime, setExamTime] = useState(null);
  const [paper, setPaper] = useState({});
  const [quiz, setQuiz] = useState(null);
  const [groups, setGroups] = useState({});

  const exam = useSelector(state => state.examState.exams[examId]);

  const small = useMedia("(max-width: 1000px)");

  const pickerModal = useModal();

  useEffect(() => {
    if (exam && !exam.quiz) {
      // setQuiz(exam.quiz);
      history.push("/exam");
    } else if (exam && exam.quiz) {
      setQuiz(exam.quiz);
      getAppTime().then(time => {
        setRemainingTime(exam.endTime - time.data);
      });
    }
    // eslint-disable-next-line
  }, [exam]);

  const [getExam, _, startExam] = useActions([
    getExamAction,
    getPaperAndQuestions,
    submitExamAction,
    startExamAction
  ]);

  function orderQuestions() {}

  async function getPaperAndQuestions(examKey, paperKey) {
    try {
      let paper = await getPaper(paperKey);
      setPaper(paper);
      let questions = await getQuestionsForPaper(paper.paperKey);
      setQuestions(paper.questionKeys.map(i => questions[i]));
      let groups = await getGroupsForPaper(paper.paperKey);
      setGroups(groups);
    } catch (e) {
      console.log(e);
      throw e;
    }
  }

  // Set current question to first question after page loads
  useEffect(() => {
    if (questions.length) {
      if (currentQuestionKey) {
        return;
      }
      setCurrentQuestionKey(paper.questionKeys[0]);
      setLocalLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions]);

  // Add current question to list of played/viewed question
  useEffect(() => {
    setPlayed(playedQuestions => [...playedQuestions, currentQuestionKey]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentQuestionKey]);

  //Add listener to live quiz document to keep updated with the progress of exam
  useEffect(() => {
    if (exam && exam.quiz) {
      let unsubscribe = firestoreRef
        .collection("live_quiz")
        .doc(exam.quiz.key)
        .onSnapshot(doc => {
          // dispatch({ type: "GET_USER_QUIZ", payload: doc.data() });
          setQuiz(doc.data());
        });
      return () => unsubscribe();
    }
  }, [exam]);

  // Check if no quiz , and redirect if no. This is to solve the issue where quiz is null if you refresh or directly navigate to the page
  useEffect(() => {
    if (quiz && quiz.completed) {
      history.push("/exam");
    }
  }, [quiz, history]);

  // get exam is no exam is present
  useEffect(() => {
    if (!exam) {
      history.push("/exam");
    }
    // eslint-disable-next-line
  }, []);

  // get paper if paper not exusts
  useEffect(() => {
    if (exam) {
      getPaperAndQuestions(exam.examKey, exam.paperKey);
    }
    // eslint-disable-next-line
  }, [exam, getPaper, quiz]);

  //Start exam and start timer for exam
  useEffect(() => {
    if (exam && quiz && !examTime) {
      startExam(exam.endDate, quiz.quizKey);
    }
    // eslint-disable-next-line
  }, []);

  function answerAQuestion(key, answer) {
    let update = {};
    let updatekey = "progress." + key;
    update[updatekey] = answer;
    return firestoreRef
      .collection("live_quiz")
      .doc(quiz.key)
      .update(update);
  }

  function submitExam() {
    firestoreRef
      .collection("live_quiz")
      .doc(quiz.key)
      .update({ completed: true });
  }

  function changeQuestion(key) {
    if (small) {
      pickerModal.close();
    }
    setCurrentQuestionKey(key);
  }

  const getKeysAndCurrentKeys = () => {
    let keys = paper.questionKeys;
    let current_key = keys.indexOf(currentQuestionKey);
    return { keys, current_key };
  };

  const changeQuestionToRight = () => {
    let { keys, current_key } = getKeysAndCurrentKeys();
    if (current_key === keys.length - 1) {
      setCurrentQuestionKey(keys[0]);
      return;
    }
    setCurrentQuestionKey(keys[current_key + 1]);
  };

  const changeQuestionToLeft = () => {
    let { keys, current_key } = getKeysAndCurrentKeys();
    if (current_key === 0) {
      setCurrentQuestionKey(keys[keys.length - 1]);
      return;
    }
    setCurrentQuestionKey(keys[current_key - 1]);
  };

  const getQuestionNumber = () => {
    let questionNumber = paper.questionKeys.indexOf(currentQuestionKey) + 1;
    return questionNumber;
  };

  function getQuestionGroup(key) {
    console.log("@@pro key", key);
    let question = questions.find(i => i.questionKey === key);
    return groups[question.groupKey] || null;
  }

  if (localLoading) return <FullScreenLoader />;
  // if(examTime)
  else if (!exam)
    return (
      //TODO: Center ma majale Ooops, times up, submitting bhanera loading dekhaune
      <Page style={{ justifyContent: "center" }}>Submitting your text</Page>
    );

  console.log("@@questions", questions);
  console.log("@@paper", paper);
  console.log("@@progress", quiz.progress);
  console.log("@@quiz", quiz);
  return (
    <React.Fragment>
      {small && (
        <Modal {...pickerModal.props} transition={Fade}>
          <QuestionPicker
            onQuestionChange={changeQuestion}
            currentQuestionKey={currentQuestionKey}
            progress={quiz.progress}
            playedQuestions={playedQuestions}
            keys={paper.questionKeys}
          />
        </Modal>
      )}
      <HeaderBanner
        title={exam.name}
        subtitle="Please check the submit button."
      >
        <Typography>Time Remaining</Typography>
        {remainingTime && (
          <Countdown
            date={Date.now() + remainingTime}
            daysInHours
            onComplete={submitExam}
          />
        )}
      </HeaderBanner>
      <Page>
        <NContainer>
          <Row justify="center">
            <div style={{ margin: "0 10px", width: "600px" }}>
              <Question
                questionKey={currentQuestionKey}
                question={questions.find(
                  i => i.questionKey === currentQuestionKey
                )}
                progress={quiz.progress}
                onSubmit={answerAQuestion}
                group={getQuestionGroup(currentQuestionKey)}
                questionNumber={getQuestionNumber()}
              />
              <ExamNavButtons
                changeQuestionToLeft={changeQuestionToLeft}
                changeQuestionToRight={changeQuestionToRight}
                openPicker={() => pickerModal.open()}
              />
            </div>
            {!small && (
              <div style={{ margin: "0 10px" }}>
                <QuestionPicker
                  onQuestionChange={changeQuestion}
                  currentQuestionKey={currentQuestionKey}
                  progress={quiz.progress}
                  playedQuestions={playedQuestions}
                  keys={paper.questionKeys}
                />
              </div>
            )}
          </Row>
        </NContainer>
      </Page>
      <SubmitExam submitExam={submitExam} />
    </React.Fragment>
  );
}

function ExamNavButtons({
  changeQuestionToLeft,
  changeQuestionToRight,
  openPicker
}) {
  const small = useMedia("(max-width: 1000px)");
  let size = small ? 50 : 35;
  return (
    <Row justify="flex-end" style={{ marginTop: "20px" }}>
      <ChevronLeft
        style={{
          borderRadius: "100%",
          cursor: "pointer",
          width: size,
          height: size,
          marginRight: "1em",
          backgroundColor: "white",
          boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 6px 6px -3px, rgba(0, 0, 0, 0.14) 0px 10px 14px 1px, rgba(0, 0, 0, 0.12) 0px 4px 18px 3px"
        }}
        onClick={changeQuestionToLeft}
      />
      {small && (
        <NumbersIcon
          style={{
            borderRadius: "100%",
            cursor: "pointer",
            width: size,
            height: size,
            marginRight: "1em",
            padding: "5px",
            backgroundColor: "white",
            boxShadow:
              "rgba(0, 0, 0, 0.2) 0px 6px 6px -3px, rgba(0, 0, 0, 0.14) 0px 10px 14px 1px, rgba(0, 0, 0, 0.12) 0px 4px 18px 3px"
          }}
          onClick={openPicker}
        />
      )}
      <ChevronRight
        style={{
          borderRadius: "100%",
          cursor: "pointer",
          width: size,
          height: size,
          backgroundColor: "white",
          boxShadow:
            "rgba(0, 0, 0, 0.2) 0px 6px 6px -3px, rgba(0, 0, 0, 0.14) 0px 10px 14px 1px, rgba(0, 0, 0, 0.12) 0px 4px 18px 3px"
        }}
        onClick={changeQuestionToRight}
      />
    </Row>
  );
}
